import { MutableRefObject, RefObject, useEffect } from 'react';
import { writeSavedScrollPosition } from '@monorepo/shared/utils/navigation/scrollPositionStorage';
import debounce from 'lodash.debounce';

// useSaveScrollPosition will save the given position of the scrollbar
export function useSaveScrollPosition(
  storageKey: string,
  isReady: boolean,
  scrollContainerRef: RefObject<HTMLElement | null>,
  allowScrollSaveRef: MutableRefObject<boolean>,
) {
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container || !storageKey) {
      return undefined;
    }

    const savePosition = () => {
      if (!isReady || !allowScrollSaveRef.current) {
        return;
      }
      writeSavedScrollPosition(storageKey, container.scrollTop);
    };

    // continually save every 150ms
    const debouncedSave = debounce(savePosition, 150);
    container.addEventListener('scroll', debouncedSave, { passive: true });

    // saves one last time directly when leaving the page without a final scroll event
    window.addEventListener('pagehide', savePosition);

    return () => {
      debouncedSave.flush();
      debouncedSave.cancel();

      container.removeEventListener('scroll', savePosition);
      window.removeEventListener('pagehide', savePosition);
    };
  }, [allowScrollSaveRef, isReady, scrollContainerRef, storageKey]);
}
